// React
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { ServicesInjection } from '../../containers/servicesInjection';

// Hooks
import { useLoading } from '../../../../hook/useLoading';

// View
import { ServicesFormPage } from './view';

export const ServicesForm = () => {
  const [isDisponibleInSite, setIsDisponibleInSite] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const [service, setService] = useState({});

  const { getServices, createServices, updateServices, services, success } =
    ServicesInjection();

  const history = useHistory();
  const { loadingWithTime } = useLoading();

  const findAssociate = (id) => {
    const service = services.find((associate) => associate.id === id);

    if (service) {
      setService(service);
      setIsActive(service.active === true);
      setIsDisponibleInSite(service.available_site === true);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: service ? service.name : '',
      descriptionInput: service ? service.description : '',
      priceInput: service ? service.price : '',
    },
    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      descriptionInput: Yup.string().nullable(),
      priceInput: Yup.number().required('Preço é obrigatório'),
      isActiveSelect: Yup.string().nullable(),
      isDiedSelect: Yup.string().nullable(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        id: service.id,
        name: values.nameInput || null,
        description: values.descriptionInput || null,
        price: values.priceInput || null,
        available_site: isDisponibleInSite,
        active: isActive,
      };

      loadingWithTime(1000);
      if (service.id) {
        updateServices(service.id, valuesToSubmit);
        history.goBack();
      } else {
        createServices(valuesToSubmit);
        history.goBack();
      }
    },
  });

  useEffect(() => {
    getServices();
  }, [success]);

  useEffect(() => {
    const full_url = document.URL; // Get current url
    const url_array = full_url.split('/'); // Split the string into an array with / as separator
    const last_segment = url_array[url_array.length - 1];
    findAssociate(last_segment);
  }, [services]);

  return (
    <ServicesFormPage
      service={service}
      history={history}
      isActive={isActive}
      validation={validation}
      setIsActive={setIsActive}
      isDisponibleInSite={isDisponibleInSite}
      setIsDisponibleInSite={setIsDisponibleInSite}
    />
  );
};
